import React from 'react';
import WorldDbHeader from './WorldDbHeader';
import OfferCreator from './OfferCreator/OfferCreator';
import { useNavigate, useParams } from 'react-router-dom';
import './WorldDb.css';

const DealWizardPage = () => {
  const navigate = useNavigate();
  const { offerId } = useParams();

  return (
    <div className="worldDbMain">
      <WorldDbHeader activeView="offerCreator" setActiveView={() => {}} />
      <OfferCreator 
        offerIdFromUrl={offerId} 
        onNavigate={(path) => navigate(path)} 
      />
    </div>
  );
};

export default DealWizardPage;

